import React, { useEffect, useRef } from "react";
import './blog.css';
import s1 from '../../Assets/sponsors/1.png'
import s2 from '../../Assets/sponsors/2.png'
import s3 from '../../Assets/sponsors/3.png'
import s4 from '../../Assets/sponsors/4.png'
import s5 from '../../Assets/sponsors/5.png'
import s6 from '../../Assets/sponsors/6.png'
import s7 from '../../Assets/sponsors/7.png'
import s8 from '../../Assets/sponsors/8.png'
import s9 from '../../Assets/sponsors/9.png'
import s10 from '../../Assets/sponsors/10.png'
import s11 from '../../Assets/sponsors/11.png'
import s12 from '../../Assets/sponsors/12.png'
import s13 from '../../Assets/sponsors/13.png'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Post = [
  {
    postImage: s1,

  },
  {
    postImage: s2,
  },
  {
    postImage: s3,

  },
  {
    postImage: s4,
  },
  {
    postImage: s5,
  },
  {
    postImage: s6,
  },
  {
    postImage: s7,
  },
  {
    postImage: s8,
  },
  {
    postImage: s9,
  },
  {
    postImage: s10,
  },
  {
    postImage: s11,
  },
  {
    postImage: s12,
  },
  {
    postImage: s13,
  }
]
const Blog = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = 320;

    if (direction === 'left') {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="blog container section">
      <div className="secContainer">
        <div className="secIntro">
          <h2 data-aos="fade-up" className="secTitle">Collaboration & Sponsors</h2>
        </div>

        <div className="scrollWrapper">
          <button className="scrollBtn left" onClick={() => scroll('left')}>
            <IoIosArrowBack className="icon" />
          </button>

          <div ref={scrollRef} className="mainContainer horizontalScroll">
            {Post.map(({ postImage, title, desc }) => (
              <div className="singlePost">
                <div className="postDetails">
                  <img
                    src={postImage}
                    alt="Event"
                    className="popupImage"
                  />
                </div>
              </div>
            ))}
          </div>

          <button className="scrollBtn right" onClick={() => scroll('right')}>
            <IoIosArrowForward className="icon" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Blog;